import { type Distribution } from '@/infra/services/catalog/review/model';

const formatDistribution = (rawDistribution: Distribution[]) => {
  const distribution = new Array(5)
    .fill({})
    .map((_, index) => {
      const value = index + 1;

      const count =
        rawDistribution.find((item) => item.value === value)?.count ?? 0;

      return {
        value,
        count,
      };
    })
    .reverse();

  return distribution;
};

export default formatDistribution;
